import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage.jsx";
import CertificatePage from "./components/CertificateView.jsx";
import AdminLogin from "./components/admin/Login.jsx";
import AdminDashboard from "./components/admin/Dashboard.jsx";
import AddCertificate from "./components/admin/AddCertificate.jsx";
import ProtectedRoute from "./components/admin/ProtectedRoute.jsx";
import "./App.css";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/certificate/:username" element={<CertificatePage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/add-certificate" element={
          <ProtectedRoute>
            <AddCertificate />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
};

export default App;
